import * as React from "react";
import Button from "../../../components/Button";
import TextField from "../../../components/TextField";

interface INotesAndNewsHeader {
    onFilter: (event: React.FormEvent<{}>, newValue: string) => void;
    openDialog: () => void;
    onEdit: () => void;
    getNews: () => void;
    canEdit: boolean;
    canCreate: boolean;
    editMode: boolean;
    filterValue?: string;
    t: reactI18Next.TranslationFunction;
}

export const NotesAndNewsHeader: React.SFC<INotesAndNewsHeader> = (props: INotesAndNewsHeader) => {

    return (
        <React.Fragment>
            <div>
                {props.canCreate &&
                    <Button
                        label={props.t("NOTES_AND_NEWS:ADD_NOTE_NEWS")}
                        labelPosition="after"
                        icon="add"
                        onClick={props.openDialog}
                    />
                }
                {props.canEdit &&
                    <Button
                        icon={props.editMode ? "close" : "pencil"}
                        labelPosition={'after'}
                        label={props.t(props.editMode ? "GLOBAL:STOP_EDITING" : "GLOBAL:START_EDITING")}
                        onClick={props.onEdit}
                    />
                }
                <Button
                    label={props.t("GLOBAL:RELOAD")}
                    labelPosition="after"
                    icon="refresh"
                    onClick={props.getNews}
                />
            </div>
            <TextField
                placeholder={props.t("NOTES_AND_NEWS:FILTER_NOTES_AND_NEWS")}
                value={props.filterValue}
                onChange={props.onFilter}
            />
        </React.Fragment>
    );
};

export default NotesAndNewsHeader;



// WEBPACK FOOTER //
// ./src/views/AdminView/NotesAndNewsTab/NotesAndNewsHeader.tsx